<template>
  <ubi-page-container>

    <el-form @submit.prevent.native="fetchList">
      <ubi-panel style="background-color: #EBF3F2;">
        <ubi-search-container
            @filter="doFilter"
            :defaultFilter="this.filter.presetPosts"
            v-on:resetfilter="doFilter('reset')"
            :more-opened="filter.advanced"
            @update:more-opened="advanced => setFilter({ advanced })">
          <el-form-item :label="$t('contacts.visites.searchByReference')">
            <el-input type="text" @input="setSearch" :value="filter.search" :placeholder="$t('contacts.visites.searchByReference')" />
          </el-form-item>
        </ubi-search-container>
      </ubi-panel>
    </el-form>

    <ubi-panel v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')">
      <ubi-list-header slot="header"
                       :limits="limits"
                       :page.sync="page"
                       :limit.sync="limit"
                       :total="results.count"
                       :sort.sync="sort"
                       :sortProperties="sortProperties"
                       :defaultFilter="this.filter.preset"
                       @filter="doFilter"
      ></ubi-list-header>
      <ubi-list-footer slot="footer" :limits="limits" :page.sync="page" :limit.sync="limit" :total="visites.count"></ubi-list-footer>
      <el-table ref="table" :data="visites.data">
        <el-table-column width="120">
          <template v-slot="{ row: visite }">
            <img width="80" v-if="visite.photoMiniature != null" alt="" :src="visite.photoMiniature" :srcset="visite.photoMiniature" />
            <div v-else style="text-align: center;">
              <ubi-icon class="no-photo" name="camera" size='60'/>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="dateVisite" :label="$t('contacts.visites.columnDateVisite')" width="180" align="center">
          <template v-slot="{ row: visite }">
            {{ visite.dateVisite }} {{ visite.horaireVisite }}
          </template>
        </el-table-column>
        <el-table-column prop="refAnnonce" :label="$t('contacts.visites.columnAdReference')" width="120">
          <template v-slot="{ row: visite }">
            <router-link :to="{ name: 'post-view', params: { post: visite.idAnnonce } }">
              {{ visite.refAnnonce }}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.visites.columnAdStatut')" width="120" align="center">
          <template v-slot="{ row: visite }">
            {{ visite.etatAnnonce == 'A' ? $t('contacts.visites.adActive') : $t('contacts.visites.adInactive') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.visites.columnJaugeVisite')" width="140" align="center">
          <template v-slot="{ row: visite }">
            {{ visite.nbInscrit }} / {{ visite.nbPersonne }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.visites.columnNbAttente')" width="120" align="center">
          <template v-slot="{ row: visite }">
            {{ visite.nbFileAttente }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('contacts.visites.columnListeCandidatsExport')" width="140" align="center">
          <template v-slot="{ row: visite }">
            <div v-if="visite.candidats.length > 0">
              <download-excel :data="visite.candidats" :fields="jsonFields" :name="`candidats-visite-${visite.id}.xls`">
                <ubi-icon name="export" class="Route-icon" style="cursor: pointer;" />
              </download-excel>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </ubi-panel>
  </ubi-page-container>
</template>

<script>
import UbiPanel from '../../components/Panel'
import { getVisites } from '@/services/visites.js'
import { mapMutations, mapState } from 'vuex'
import JsonExcel from 'vue-json-excel'
import Vue from 'vue'
import { getContactsAll } from '@/services/contacts'
import moment from "moment/moment";

export default {
  name: 'contacts-visites',
  components: { UbiPanel },
  data () {
    return {
      visites: [],
      loading: false,
      offset: 0,
      limits: [10, 10 * 2, 10 * 5],
      sortProperties: {
        '-DC': this.$t('general.sort.decreaseDate'),
        DC: this.$t('general.sort.increaseDate'),
        R: this.$t('general.sort.reference')
      },
      nbResults: 0,
      jsonFields: {
        'Civilité': 'civilite',
        'Prénom': 'prenom',
        'Nom': 'nom',
        'Email': 'email',
        'Téléphone': 'telephone',
        'Statut visite': 'status'
      }
    }
  },
  beforeMount () {
    Vue.component('downloadExcel', JsonExcel)
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    doFilter (type) {
      switch (type) {
        case 'reset':
          this.filter.search = ''
          break
      }
      this.fetchList()
    },
    async fetchList () {
      this.loading = true
      const visitesFilters = {
        post: {
          reference: this.filter.search,
          advertiser: { id: this.user.advertiser }
        },
        withAds: true,
        page: this.page,
        size: this.limit
      }
      switch (this.filter.sort) {
        case '-DC':
          visitesFilters.sort = 'date_debut'
          visitesFilters.direction = 'desc'
          break
        case 'DC':
          visitesFilters.sort = 'date_debut'
          break
        case 'R':
          visitesFilters.sort = 'ref_annonce'
          break
        default:
          visitesFilters.sort = 'date_debut'
          visitesFilters.direction = 'desc'
      }

      const dataVisites = await getVisites(visitesFilters)
      this.setResults(dataVisites)
      if (dataVisites && dataVisites.count > 0) {
        dataVisites.data.forEach((element) => {
          const dateDebut = new Date(element.dateDebut)
          element.dateVisite = moment.utc(dateDebut).format('DD/MM/YYYY')
          element.horaireVisite = moment.utc(dateDebut).format('HH:mm')
          let nbInscrit = 0
          let nbFileAttente = 0
          if (element.candidats.length > 0) {
            element.candidats.forEach(async (candidat) => {
              if (candidat.status === 'OUI') {
                nbInscrit++
              } else if (candidat.status === 'FILE_ATTENTE') {
                nbFileAttente++
              }
              const contactsFilters = {}
              contactsFilters.reference = element.refAnnonce
              contactsFilters.mail = candidat.email
              const dateBefore = moment().subtract(6, 'months')
              contactsFilters.beforeContacts = moment(dateBefore).format('YYYY-MM-DD')
              const contacts = await getContactsAll(contactsFilters)
              if (contacts.contact_mailtracking && (contacts.contact_mailtracking.length > 0)) {
                const contact = contacts.contact_mailtracking[0]
                candidat.civilite = contact.civilite
                candidat.prenom = contact.prenom
                candidat.nom = contact.nom
                candidat.telephone = contact.telephone
              }
            })
          }
          element.nbInscrit = nbInscrit
          element.nbFileAttente = nbFileAttente
        })
      }
      this.visites = dataVisites
      this.loading = false
    },
    ...mapMutations('contactsListPosts', [
      'setPage',
      'setLimit',
      'setSort',
      'setResults',
      'setOffset',
      'setSearch',
      'resetFilter',
      'setFilter',
      'addFilter'
    ])
  },
  computed: {
    ...mapState('contactsListPosts', ['filter', 'results']),
    user () {
      return this.$store.getters.getUser
    },
    page: {
      get () {
        return this.filter.page
      },
      set (value) {
        this.setOffset((value - 1) * this.limit)
        this.setPage(value)
        this.fetchList()
        return this.setPage(value)
      }
    },
    limit: {
      get () {
        return this.filter.limit
      },
      set (value) {
        this.setLimit(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setLimit(value)
      }
    },
    sort: {
      get () {
        return this.filter.sort
      },
      set (value) {
        this.setSort(value)
        this.setOffset(0)
        this.setPage(1)
        this.fetchList()
        return this.setSort(value)
      }
    }
  }
}
</script>

<style scoped>
</style>
